import { App } from 'app/widget/app.module.js';

new App();
